import api from '../api';

export const editProduct = async (body, id: number) => {
	const url = `/produto?id=${id}`;
	const response = await api.patch(url, body);
	return response.data;
};

export const deleteProduct = async (id: number) => {
	const response = await api.delete(`produto?id=${id}`);
	return response.data;
};

export const deleteProductByFilters = async (filters: any) => {
	const response = await api.post('produto/deletarPorFiltros', filters);
	return response.data;
};
